<template>
  <div class="authentication-content">
    <Row>
      <Col class="demo-spin-col" span="8">
      </Col>
    </Row>
  </div>
</template>

<script>
  import {apiLogin, removeSession, setSession} from '../../services/Authentication.service'
  import {getLoggedUser} from '../../services/User.service'
  import {getEvents} from '../../services/Events.service'
  import {getLicenses} from '../../services/Licenses.service'
  import {getCompanyById} from '../../services/Companies.service'
  import {mapActions, mapGetters} from 'vuex'
  import Router from '../../router';
  import {bus} from '../../main'

  export default {
    data() {
      return {
        data: null,
      }
    },
    computed: {
      ...mapGetters(['getUserDetails', 'getAdminUser']),
      ...mapGetters(['getEvent', 'getEventList']),
      ...mapGetters(['getCompanyDetail', 'getCompanyListDetail']),
      ...mapGetters(['getLicenseDetail', 'getLicenseListDetail']),
    },
    methods: {
      ...mapActions(['setUserDetails', 'setAdminUser']),
      ...mapActions(['setEvent', 'setEventList']),
      ...mapActions(['setCompanyDetail', 'setCompanyListDetail']),
      ...mapActions(['setLicenseDetail', 'setLicenseListDetail']),

      handleSubmit() {
        let queries = JSON.parse(localStorage.getItem('API_Query'));
        let hash = queries.hash;
        let eventId = queries.eventId;
        localStorage.setItem('selected_event', eventId);
        let authData = {userName: hash};

        apiLogin(authData).then(response => {
          let userName = response.data.userName;
          setSession(response.data, userName);
          getLoggedUser(userName)
            .then(userObj => {
              this.setUserDetails(userObj.data);
              localStorage.setItem('fullName', userObj.data.firstName + ' ' + userObj.data.lastName); 
              if (userObj.data.userRoleId === 1) {
                localStorage.setItem('role', 'admin');
              } else {
                if (userObj.data.userRoleId === 2) {
                  localStorage.setItem('role', 'manager');
                } else {
                  localStorage.setItem('role', 'user');
                }
              }

              localStorage.setItem('companyId', userObj.data.companyId);
              getCompanyById(userObj.data.companyId).then(companiesObj => {
                let companies = [];
                companies.push({
                  companyId: companiesObj.data.companyId,
                  companyName: companiesObj.data.companyName,
                  address: companiesObj.data.address,
                  barcode: companiesObj.data.barcode,
                  city: companiesObj.data.city,
                  country: companiesObj.data.country,
                  deleted: companiesObj.data.deleted,
                  email: companiesObj.data.email,
                  logoUrl: companiesObj.data.logoUrl,
                  phone: companiesObj.data.phone,
                  eventIds: companiesObj.data.eventIds,
                  formIds: companiesObj.data.formIds,
                  languageId: companiesObj.data.languageId,
                  leadIds: companiesObj.data.leadIds,
                  licenseIds: companiesObj.data.licenseIds,
                });
                localStorage.setItem('companies', JSON.stringify(companies));
                localStorage.setItem('selected_company', companies[0].companyId);
                sessionStorage.setItem('companyName', companies[0].companyName);
                this.setCompanyListDetail(companies);
                this.setCompanyDetail(companies[0]);
                this.userIcon = companiesObj.data.logoUrl;

                let events = [];
                let eventIds = companiesObj.data.eventIds;
                localStorage.setItem('eventIds', JSON.stringify(eventIds));

                getLicenses(false, userObj.data.companyId)
                  .then(lic => {
                    this.setLicenseListDetail(lic.data);

                    getEvents(false)
                      .then(eventsObj => {
                        eventsObj.data.map((evt) => {
                          for (let i = 0; i < eventIds.length; ++i) {
                            if (eventIds[i] === evt.eventId) {
                              let returnData = {
                                eventName: evt.eventName,
                                eventId: evt.eventId,
                                startDate: evt.startDate,
                                endDate: evt.endDate,
                                location: evt.location,
                                iconUrl: evt.iconUrl,
                                bannerUrl: evt.bannerUrl,
                                companyIds: evt.companyIds,
                                participantForm: evt.participantForm,
                                deleted: evt.deleted,
                              };
                              events.push(returnData);
                            }
                          }
                        });
                        this.adminLogin = false;
                       // localStorage.setItem('role', 'user');
                        localStorage.setItem('events', JSON.stringify(events));
                        let defaultEvent = events.filter(a => a.eventId === parseInt(eventId))[0];
                        if (defaultEvent) {
                          localStorage.setItem('selected_event', defaultEvent.eventId);
                          this.setEvent(defaultEvent);
                        } else if(events.length > 0) {
                          localStorage.setItem('selected_event', events[0].eventId);
                          this.setEvent(events[0]);
                        } else {
                          localStorage.setItem('selected_event', eventId);
                          this.setEvent(eventId);
                        }
                        this.setEventList(events);
                        this.$emit('collectEventsData', events, companies);
                        bus.$emit('reloadSideMenu', events, companies);

                        //routing
                        if (!userObj.data.companyId) {
                          Router.push({name: 'GlobalAdministration'});
                        } else {
                          Router.push({name: 'GeneralDashboard'});
                        }
                      })
                      .catch(error => {
                        console.log('Get Events Failed - LN 151 Login - ' + error);
                      });
                  })
                  .catch(error => {
                    console.log('Get Licenses Failed - LN 164 - ' + error);
                  });
              });
            })
            .catch(error => {
              this.$Message.error('Authentication Failed');
              removeSession();
              Router.push({name: 'Authentication'});
            });
        });
      },
      handleSpinCustom () {
        this.$Spin.show({
          render: (h) => {
            return h('div', [
              h('Icon', {
                'class': 'demo-spin-icon-load',
                props: {
                  type: 'ios-loading',
                  size: 18
                }
              }),
              h('div', 'Loading')
            ])
          }
        });
      }
    },
    created() {
      this.handleSpinCustom();
      this.handleSubmit();
    },
    mounted() {
      this.handleSpinCustom();
      // const self = this;
      // setTimeout(function () {
      //   self.handleSubmit();
      // }, 300);
    }
  }
</script>
<style>
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
</style>



// WEBPACK FOOTER //
// src/components/g_authentication/Login.vue